import { withSpinner, success } from "../../../../redux/actions/utilities";
import { customToast } from "../../../../shared";
import {
  archivedQuestionsConstants,
  successMessages,
  toastTypes,
} from "../../constants";
import { archivedQuestionsSerive } from "../../services";

const { GET_ARCHIVED_QUESTIONS, REACTIVATE_QUESTION } =
  archivedQuestionsConstants;

const getArchiveQuestionsByBrandId = (brandId) => (dispatch) => {
  withSpinner(dispatch, GET_ARCHIVED_QUESTIONS, () =>
    archivedQuestionsSerive
      .getArchiveQuestionsByBrandId(brandId)
      .then(
        (response) => {
          dispatch(success(response, GET_ARCHIVED_QUESTIONS));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

const reActivateArchivedQuestion = (brandId, questionId) => (dispatch) => {
  return withSpinner(dispatch, REACTIVATE_QUESTION, () =>
    archivedQuestionsSerive
      .reActivateArchivedQuestion(brandId, questionId)
      .then(
        (response) => {
          dispatch(success(response, REACTIVATE_QUESTION));
          customToast(
            successMessages.REACTIVATE_ARCHIVED_QUESTION_SUCCESSFULLY,
            toastTypes.SUCCESS
          );
          dispatch(getArchiveQuestionsByBrandId(brandId));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          throw error;
        }
      )
  );
};

export const archivedQuestionsActions = {
  reActivateArchivedQuestion,
  getArchiveQuestionsByBrandId,
};
